const About = () => {
  return (
    <div className="about-us-div">
      <h1 className="about-us-header">About Us</h1>
      <p className="my-3">
        Welcome to our website, your ultimate destination for all things
        film-related! We are not another streaming service; we are your go-to
        information provider, offering a vast collection of movies for you to
        explore and discover.
      </p>
      <p className="my-3">
        We are passionate about cinema and believe that every film has a story
        to tell. Our goal is to bring you an immersive experience where you can
        delve into the world of movies, browse through a great variety of
        genres, and find that perfect film for your mood or occasion.
      </p>
      <p className="my-3">
        Our user-friendly interface allows you to easily navigate through our
        extensive film database. Whether you're in the mood for action, romance,
        comedy, drama, or even something more niche like sci-fi or documentary,
        we've got you covered. With just a few clicks, you can browse through
        our carefully curated collection and find the films that pique your
        interest.
      </p>
      <p className="my-3">
        In addition to browsing by genre, our website also offers general
        selection of films, allowing you to explore the latest releases and stay
        up-to-date with the newest trends in the film industry. There you can
        easily discover hidden gems or critically acclaimed masterpieces.
      </p>
      <p className="my-3">
        Each film listing on our website provides comprehensive information,
        that enables you to make informed decisions and choose the movies that
        resonate with your preferences and interests. Whether you're a film
        buff, a casual moviegoer, or simply someone looking for entertainment,
        we've got the information you need.
      </p>
      <p className="my-3">
        Join us on this cinematic journey as we celebrate the art of
        storytelling through the magic of film. Explore, discover, and immerse
        yourself in a world of captivating stories and unforgettable moments.
        Welcome to our website, your ultimate film companion!
      </p>
    </div>
  );
};

export default About;
